"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Product = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var react_redux_1 = require("react-redux");
var react_router_1 = require("react-router");
var react_query_1 = require("@tanstack/react-query");
var classnames_1 = __importDefault(require("classnames"));
var actions_1 = require("../../store/cart/actions");
var Modal_1 = require("../../components/Modal");
var hooks_1 = require("../../hooks");
var actions_2 = require("../../store/product/actions");
var Burger_1 = require("../../components/Shared/Burger");
var CounterButton_1 = require("../../components/CounterButton");
var ModifierCategories_1 = require("./ModifierCategories");
var StockInformer_1 = require("../../components/StockInformer");
require("./product.scss");
var validateModifierGroups = function (item) {
    var _a;
    if (!item)
        return;
    var checked = true;
    (_a = item.modifier_groups) === null || _a === void 0 ? void 0 : _a.every(function (category) {
        if (category.is_required) {
            if (category.max_amount) {
                var count = category.modifier_items.reduce(function (acc, item) { return (item.checked ? acc + 1 : acc); }, 0);
                checked = category.max_amount === count;
            }
            else {
                checked = category.modifier_items.some(function (item) { return item.checked; });
            }
        }
        return checked;
    });
    return checked;
};
exports.Product = react_1.default.memo(function () {
    var _a;
    var _b, _c, _d, _e;
    var setFilters = (0, hooks_1.useSetFilters)();
    var location = (0, react_router_1.useLocation)();
    var dispatch = (0, react_redux_1.useDispatch)();
    var t = (0, react_i18next_1.useTranslation)().t;
    var queryClient = (0, react_query_1.useQueryClient)();
    var _f = (0, react_1.useState)(0), modifiersPrice = _f[0], setModifiersPrice = _f[1];
    var restaurantId = (0, react_router_1.useParams)().restaurant;
    var searchParams = new URLSearchParams(location.search);
    var type = searchParams.get("type") || "";
    var productId = searchParams.get("product") || "";
    var basketProductId = searchParams.get("basketProduct") || null;
    var menus = (0, react_1.useMemo)(function () { return queryClient.getQueryData(["restaurant-menu", restaurantId, type]); }, [restaurantId]);
    var currency = (0, react_redux_1.useSelector)(function (state) { var _a; return (_a = state.app.chain) === null || _a === void 0 ? void 0 : _a.currency; });
    var item = (0, react_redux_1.useSelector)(function (state) { return state.product; });
    var dishInsideBasket = (0, react_redux_1.useSelector)(function (state) { return state.cart.items.find(function (_, index) { return String(index) === basketProductId; }); }, react_redux_1.shallowEqual);
    var basketItems = (0, react_redux_1.useSelector)(function (state) { return state.cart.items; });
    var categories = (0, react_1.useMemo)(function () { return Object.values(menus || {}).flatMap(function (menu) { return (__spreadArray([], menu.categories, true)); }); }, [restaurantId]);
    var flatDishes = (0, react_1.useMemo)(function () { return categories.flatMap(function (menu) { return (__spreadArray([], menu.dishes, true)); }); }, [restaurantId]);
    var productPrice = (item === null || item === void 0 ? void 0 : item.price) || 0.0;
    var counter = (item === null || item === void 0 ? void 0 : item.quantity) || 1;
    var basketItemsCount = basketItems.reduce(function (prev, curr) {
        if (curr.id === item.id) {
            return prev + curr.quantity;
        }
        return prev;
    }, 0);
    var stockLimit = (item === null || item === void 0 ? void 0 : item.stock_limit) || 0;
    var isUnlimited = item.stock_limit === null;
    var isValid = validateModifierGroups(item);
    var isOutOfStock = (item === null || item === void 0 ? void 0 : item.stock_status) === 'out_of_stock';
    var isEmpty = (item === null || item === void 0 ? void 0 : item.stock_limit) === 0;
    var isDisabled = isOutOfStock || isEmpty || (!dishInsideBasket && basketItemsCount >= stockLimit);
    var isRunningOut = !!((item === null || item === void 0 ? void 0 : item.stock_limit) && (item === null || item === void 0 ? void 0 : item.stock_limit) <= 10);
    var isPlusDisabled = dishInsideBasket ? basketItemsCount - dishInsideBasket.quantity + (item === null || item === void 0 ? void 0 : item.quantity) >= stockLimit : basketItemsCount + (item === null || item === void 0 ? void 0 : item.quantity) >= stockLimit;
    var onClose = function () {
        setFilters({ product: "", basketProduct: "" });
        setModifiersPrice(0);
    };
    var onAddOrder = function () {
        if (isValid) {
            if (productId) {
                dispatch((0, actions_1.cartAddOrder)(item, item.quantity));
                setFilters({ product: "" });
            }
            if (basketProductId !== null) {
                dispatch((0, actions_1.cartChangeOrder)(item, item.quantity, Number(basketProductId)));
                setFilters({ basketProduct: "" });
            }
        }
    };
    var onClickPlus = function () {
        dispatch((0, actions_2.addProductQuantity)());
    };
    var onClickMinus = function () {
        if (item.quantity <= 1)
            return;
        dispatch((0, actions_2.removeProductQuantity)());
    };
    (0, react_1.useEffect)(function () {
        var _a, _b;
        if (!item.id && basketProductId === null && productId) {
            var product = flatDishes === null || flatDishes === void 0 ? void 0 : flatDishes.find(function (item) { return Number(item.id) === Number(productId); });
            if (product) {
                dispatch((0, actions_2.addProduct)(product));
            }
            else {
                setFilters({ product: "" });
            }
        }
        if (item.id && productId && productId !== String(item.id || "")) {
            setFilters({ product: "" });
        }
        if ((_a = item === null || item === void 0 ? void 0 : item.modifier_groups) === null || _a === void 0 ? void 0 : _a.length) {
            var total_1 = 0.0;
            (_b = item === null || item === void 0 ? void 0 : item.modifier_groups) === null || _b === void 0 ? void 0 : _b.forEach(function (category) {
                category.modifier_items.forEach(function (modifier) {
                    if (modifier.checked && modifier.price !== null) {
                        total_1 += modifier.tax_percent !== null ? modifier.price + (modifier.price / 100) * modifier.tax_percent : modifier.price;
                    }
                });
            });
            setModifiersPrice(total_1);
        }
        else {
            setModifiersPrice(0);
        }
    }, [productId, item]);
    (0, react_1.useEffect)(function () {
        if (dishInsideBasket && !productId && basketProductId !== null) {
            dispatch((0, actions_2.addProduct)(dishInsideBasket));
        }
    }, [dishInsideBasket, basketProductId]);
    return ((0, jsx_runtime_1.jsx)(Modal_1.Modal, __assign({ className: "dish-product-modal", closeModal: onClose, isOpen: !!productId || basketProductId !== null }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "product-container" }, { children: [(0, jsx_runtime_1.jsx)("header", __assign({ className: "product-header" }, { children: (0, jsx_runtime_1.jsx)(Burger_1.Burger, { className: "product-header-close", setOpen: onClose, isOpened: true }) })), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "product-wrap" }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "product-image" }, { children: [(0, jsx_runtime_1.jsx)(StockInformer_1.StockInformer, { isOutOfStock: isOutOfStock, isRunningOut: isRunningOut, stockLimit: item.stock_limit }), (0, jsx_runtime_1.jsx)("img", { src: (_b = item === null || item === void 0 ? void 0 : item.photo_big_thumb) !== null && _b !== void 0 ? _b : item === null || item === void 0 ? void 0 : item.photo, alt: "" })] })), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "product-details" }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "product-info" }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "product-info-header" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "product-title" }, { children: (item === null || item === void 0 ? void 0 : item.title) || (item === null || item === void 0 ? void 0 : item.name) || "" })), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "product-utilities" }, { children: [((_c = item === null || item === void 0 ? void 0 : item.allergens) === null || _c === void 0 ? void 0 : _c.length) !== 0 && ((0, jsx_runtime_1.jsx)("div", __assign({ className: "category-product-info-allergens" }, { children: (_d = item === null || item === void 0 ? void 0 : item.allergens) === null || _d === void 0 ? void 0 : _d.map(function (_a) {
                                                                var name = _a.name, id = _a.id;
                                                                return (0, jsx_runtime_1.jsx)("span", { children: name }, id);
                                                            }) }))), !!(item === null || item === void 0 ? void 0 : item.weight) && (item === null || item === void 0 ? void 0 : item.weight) === 0 && (0, jsx_runtime_1.jsxs)("div", __assign({ className: "category-product-info-weight" }, { children: [item.weight, " g"] })), !!(item === null || item === void 0 ? void 0 : item.calories) && (item === null || item === void 0 ? void 0 : item.calories) === 0 && (0, jsx_runtime_1.jsxs)("div", __assign({ className: "category-product-info-weight" }, { children: [item.calories, " Kcal"] }))] }))] })), (0, jsx_runtime_1.jsx)("p", __assign({ className: "product-description" }, { children: (item === null || item === void 0 ? void 0 : item.description) || (item === null || item === void 0 ? void 0 : item.comment) || "" }))] })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "product-additional" }, { children: (_e = item === null || item === void 0 ? void 0 : item.modifier_groups) === null || _e === void 0 ? void 0 : _e.map(function (modCategory) { return ((0, jsx_runtime_1.jsx)(ModifierCategories_1.ModifierCategories, { modCategory: modCategory }, modCategory.id)); }) })), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "controls" }, { children: [(0, jsx_runtime_1.jsx)(CounterButton_1.CounterButton, { className: "controls-button-counter", counter: counter, showCounter: true, onTapMinus: onClickMinus, onTapPlus: onClickPlus, alwaysDark: true, isPlusDisabled: isUnlimited ? false : isPlusDisabled }), (0, jsx_runtime_1.jsxs)("div", __assign({ onClick: onAddOrder, className: (0, classnames_1.default)("controls-order", (_a = {}, _a["controls-order-disabled"] = isUnlimited ? false : (!isValid || isDisabled), _a)) }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "controls-order-title" }, { children: dishInsideBasket && basketProductId !== null ? t("Update") : t("Add") })), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "controls-order-amount" }, { children: [currency === null || currency === void 0 ? void 0 : currency.title, (((item === null || item === void 0 ? void 0 : item.quantity) || 0) * (productPrice + modifiersPrice)).toFixed(2)] }))] }))] }))] }))] }))] })) })));
});
